import { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
// API
import Api from '../../API';
// helpers
import { writeUserToLocalStorage } from '../../utils/helpers';
// user context
import { UserContext } from '../../userContext';

export const useLogin = () => {
  const [loading, setLoading] = useState(false);
  const [responseError, setResponseError] = useState('');

  const [_user, setUser] = useContext(UserContext);

  const navigate = useNavigate();

  const login = async (email, password) => {
    setLoading(true);
    setResponseError(false);

    const response = await Api.login(email, password);
    setLoading(false);

    if (response.error) {
      setResponseError(response.error);
    } else {
      setResponseError('');
      writeUserToLocalStorage(response.user);
      setUser(response.user);
      navigate('/home', { replace: true });
    }
  };

  return { loading, responseError, login };
};
